module.exports = __webpack_public_path__ + "98efda60d3e1573c0b480eb8a0c0a163.png";